import './index.scss'
import AnimatedLetters from '../AnimatedLetters'
import { useEffect, useState, useRef } from 'react'
import emailjs from '@emailjs/browser'

const Contact = () => {
    const [letterClass, setLetterClass] = useState('text-animate')
    const refForm = useRef()

    useEffect(() => {
        const timer = setTimeout(() => setLetterClass('text-animate-hover'), 4500)
        return () => clearTimeout(timer)
    }, [])

    const sendEmail = (e) => {
        e.preventDefault()
        emailjs.sendForm('outlook', 'template_3c86314', refForm.current, 'VqulWMZtkdbEJytTZ')
            .then(() => {
                alert('Message Sent!')
                window.location.reload(false)
            },
            () => {
                alert('Message failed to send, please try again!')
            })
    }

    return (
        <div className="container contact-page">
            <div className="text-zone">
                <h1>
                    <AnimatedLetters
                        letterClass={letterClass}
                        strArray={['Contact', 'Me']}
                        idx={17}
                    />
                </h1>
                <p>
                    If you have any questions or
                    comments, please reach out to me with
                    the form below!
                </p>
                <div className="contact-form">
                    <form ref={refForm} onSubmit={sendEmail}>
                        <ul>
                            <li className="half">
                                <input placeholder="Name" type="text" name="name" required />
                                <input placeholder="Email" type="email" name="email" required />
                            </li>
                            <li className='subject'>
                                <input placeholder="Subject" type="text" name="subject" required />
                            </li>
                            <li>
                                <textarea placeholder="Message" name="message" required></textarea>
                            </li>
                            <li>
                                <div className='button'>
                                    <input type="submit" className="send-button" value="SEND" />
                                </div>
                            </li>
                        </ul>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Contact
